import React from 'react';

import Banner from '../../components/Banner';
import Spreader from '../../components/Spreader';
import IndexSpreader from '../../components/IndexSpreader';
import IndexPromo from '../../components/IndexPromo';
import ArticlesTales from '../../components/ArticlesTales';
import Paragraph from '../../components/Paragraph';

import { Helmet } from 'react-helmet';

const IndexPage = props => (
  <div>
    <Helmet>
      <title>Главная - Специальный проект Alfa Private</title>
    </Helmet>
    <Banner
      title="Private Banking в России"
      backgroundImage="images/banners/bg.jpg"
    />
    <IndexSpreader>
      <IndexPromo>
        Private Banking в&nbsp;России появился совсем недавно, но&nbsp;уже
        занимает 10% от&nbsp;ВВП. Общее количество высокосостоятельных россиян
        превышает 28 тыс человек, и&nbsp;для них актуальна задача сохранения
        капитала для будущего поколения. Не&nbsp;стоит экспериментировать
        и&nbsp;самостоятельно искать решение, лучше воспользоваться помощью
        профессионалов. В&nbsp;Private Banking не&nbsp;только помогут сохранить
        деньги и&nbsp;решить налоговые вопросы, но&nbsp;и&nbsp;защитят частную
        жизнь. Ъ&nbsp;в&nbsp;совместном проекте с&nbsp;Альфа Private, расскажет
        об&nbsp;актуальных продуктах и&nbsp;сервисах, а&nbsp;также
        о&nbsp;технологических новинках внедряемых компанией, которые помогут
        состоятельным людям вне зависимости от&nbsp;места и&nbsp;времени
        не&nbsp;только распоряжаться сбережениями, но&nbsp;и&nbsp;отслеживать,
        на&nbsp;какой стадии находятся поставленные перед банком задачи.
        <br />
        <br />
        <b>Читайте далее:</b>
      </IndexPromo>
      <ArticlesTales
        articles={[
          {
            title: 'Private Banking - от финансов до стиля жизни',
            url: '/overview/',
            background: 'images/media/anons1-main1.jpg',
          },
          {
            title: 'Цифровые капиталы',
            url: '/digital/',
            background: 'images/media/anons2-main1.jpg',
          },
          {
            title: 'Забота о благосостоянии',
            url: '/invest/',
            background: 'images/media/anons3-main11.jpg',
          },
          {
            title: '«Наш внутренний девиз — у нас всегда есть решение»',
            url: '/interview/',
            background: 'images/media/anons4-main1.jpg',
          },
        ]}
      />
    </IndexSpreader>
  </div>
);

export default IndexPage;

// https://hackernoon.com/animated-page-transitions-with-react-router-4-reacttransitiongroup-and-animated-1ca17bd97a1a
// https://tylermcginnis.com/react-router-animated-transitions/
